import { createContext, useContext, useState, useEffect } from "react";
import { authAPI } from "../utils/api";
import axios from "axios";
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const API_URL = "https://werise.mahmoudhaleem.dev"
  // Check for existing token and user on initial load
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('access_token');

        if (token) {
          try {
            // Get user data using the stored token (this will fail if token is invalid)
            const userResponse = await axios.get(`${API_URL}/auth/users/me/`, {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            });
            setUser(userResponse.data);
          } catch (err) {
            // Token is invalid, clear it
            throw err;
          }
        }
      } catch (error) {
        console.error('Auth check error:', error);
        // If token is invalid or any other error, clear tokens
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);
  const login = async (credentials) => {
    try {
      // Get JWT tokens
      const response = await authAPI.login(credentials);
      const { access, refresh } = response.data;
      console.log('Access token:', access);

      // Store tokens
      localStorage.setItem('access_token', access);
      localStorage.setItem('refresh_token', refresh);

      // Get user data using explicit token
      const userResponse = await axios.get(`${API_URL}/auth/users/me/`, {
        headers: {
          'Authorization': `Bearer ${access}`,
          'Content-Type': 'application/json'
        }
      });
      setUser(userResponse.data);

      return { success: true };
    } catch (error) {
      console.error('Login error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || 'Login failed'
      };
    }
  };
  const logout = async () => {
    try {
      const refreshToken = localStorage.getItem('refresh_token');

      // If we have a refresh token, try to blacklist it
      if (refreshToken) {
        await authAPI.logout({ refresh: refreshToken });
      }
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Always clear tokens and user state
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      setUser(null);
    }
  };

  // Value object to be provided to consumers
  const value = {
    user,
    login,
    logout,
    loading,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);